import RestService from './RestService';

const fetchAddressAutoCompleteWithHandler = (term, handler, errorHandler) =>
  RestService.getWithHandlers(`/api/addressChecker/autoComplete?term=${term}`, handler, errorHandler);

const fetchAddress = async (addressId) => {
  try {
    const response = await RestService.get(`/api/addressChecker/addressLookup?addressId=${addressId}`);

    return { status: response.status.code, result: response.entity };
  } catch (error) {
    return { status: error.status.code, message: error.status.text };
  }
};

export default {
  fetchAddressAutoCompleteWithHandler,
  fetchAddress
};



/** WEBPACK FOOTER **
 ** ./src/services/FetchAddressService.js
 **/